import { render, staticRenderFns } from "./NotificationTemplatesTab.vue?vue&type=template&id=70d7dafa&scoped=true&"
import script from "./NotificationTemplatesTab.vue?vue&type=script&lang=js&"
export * from "./NotificationTemplatesTab.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTemplatesTab.vue?vue&type=style&index=0&id=70d7dafa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d7dafa",
  null
  
)

export default component.exports